module.exports = __webpack_public_path__ + "img/info-24px.1336f932.svg";